<script setup>
import { ref, computed } from 'vue';
import api from '@shop/frontend/web/js/api';
import Popper from 'vue3-popper';
import { useCartDataProvider } from '@vueApp/hooks/useCartDataProvider';
import useCartStore from '@vueApp/store/modules/cart';

const cartStore = useCartStore();
const { isGuest, isFastBuy } = useCartDataProvider();

const props = defineProps({
  url: {
    type: String,
    default() {
      return '';
    },
  },
  options: {
    type: Object,
    default() {
      return {};
    },
  },
  smallBtn: {
    type: Boolean,
    default: false,
  },
  ticketsCount: {
    type: Number,
    default: 0,
  },
  firstEventId: {
    type: [Number, null],
    default: null,
  },
  eventType: {
    type: String,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  price: {
    type: [Number, null],
    default: null,
  },
  isHistory: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['setAcquiringError']);

const isAcquiringPushkinOrCinema = ref(
  props.options.payType === 'Pushkin' || props.options.payType === 'Cinema',
);

const formatEventType = computed(() => (props.eventType === 'service_simple' ? 'service' : 'event'));

const acquiringButtonClass = computed(() => ({
  'js-get-fast-registration': isGuest,
  'i-acquirings-button_small': props.smallBtn,
  'i-acquirings-button_disabled': props.ticketsCount > 1 && isAcquiringPushkinOrCinema.value || props.isDisabled,
  'i-acquirings-button_history': props.isHistory,
}));

function changePayAcquiring(acquiringId) {
  api.pay
    .changePayAcquiring({ orderId: props.options.orderId, acquiringId })
    .then((res) => {
      if (isGuest) {
        // TODO открыть модалку быстрой покупки
        return;
      }

      return (window.location.href = props.url);
    })
    .catch((err) => {
      // if ($($acquiring).hasClass("js-get-fast-registration")) this.fastRegisterModal.hide();
      // TODO закрыть модалку быстрой покупки

      emit('setAcquiringError', {
        isAcquiringError: true,
        errorMessage: err.message ?? '',
      });
    });
}

function payForOrder(event) {
  const acquiringId = props.options.id;

  if (acquiringId !== 0) {
    event.preventDefault();
    changePayAcquiring(acquiringId);
    return;
  }

  if (isGuest) {
    event.preventDefault();
    cartStore.setCurrentOpenedEventId(props.firstEventId);
    cartStore.setFastBuyModalStatus(true);
    cartStore.setEventTypeToPay(formatEventType.value);
  }
}
</script>

<template>
  <button
    v-if="isGuest && !isFastBuy"
    class="btn i-acquirings-button"
    data-bs-toggle="modal"
    data-bs-target="#loginModal"
  >
    <slot>Авторизоваться для оплаты</slot>
  </button>
  <div v-else class="i-acquirings-button__link-wrapper">
    <a
      :href="url"
      class="btn btn_primary i-acquirings-button"
      :class="acquiringButtonClass"
      @click="payForOrder($event)"
    >
      <slot>
        <span v-if="isHistory"> Оплатить </span>
        <span v-else> Оплатить {{ options.id === 6 ? 'СБП' : '' }} {{ price }} ₽ </span>
      </slot>
    </a>
    <Popper
      v-if="isAcquiringPushkinOrCinema"
      class="light i-acquirings-button__popper"
      placement="top"
      arrow
      hover
      content="Вы можете оплатить заказ Пушкинской картой, только если в каждом мероприятии будет один билет."
    >
      <svg class="i-acquirings-button__pushkin-tooltip" width="12" height="12" fill="none">
        <use xlink:href="#attention" />
      </svg>
    </Popper>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-acquirings-button.scss";

:deep(.popper) {
	width: 280px;
	padding: 5px;

	border-radius: 6px;
	box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.05);
	background-color: $white;

	color: #000;
	text-align: center;
	font-size: 14px;
	font-weight: 400;
}

:deep(.popper #arrow::before) {
	transform: translateX(-5px) rotate(45deg);
	background: $white;
}
</style>
